export function RequestFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M10 5a3.001 3.001 0 01-2 2.83v8.34a3.001 3.001 0 11-2 0V7.83A3.001 3.001 0 1110 5zM15 6.6V3.4c0-.329-.47-.517-.8-.32l-2 1.52c-.133.08-.2.28-.2.4s.067.32.2.4l2 1.52c.33.197.8.009.8-.32z"
      ></path>
      <path fill="currentColor" d="M15 4a3 3 0 013 3v9.17a3.001 3.001 0 11-2 0V7a1 1 0 00-1-1V4z"></path>
    </svg>
  );
}
